import React from 'react';

function TextError(props) {
  return (
    <div
      style={{
        color: '#EA3546',
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: '13px',
        margin: '3px 0 0 10px'
      }}
    >
      {props.children}
    </div>
  );
}

export default TextError;
